import React from "react";
import "./Breadcrumb_Comp.css";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import { Link } from "react-router-dom";

const Breadcrumb_Comp = ({ data }) => {
  return (
    <div className="Breadcrumb_comp">
      <Breadcrumb>
        {data?.map((item, index) => {
          const isLast = index === data.length - 1;

          return (
            <Breadcrumb.Item
              key={index}
              linkAs={!isLast ? Link : "span"}   // Use Link only if not active
              linkProps={!isLast ? { to: item.link } : {}}
              active={isLast}
            >
              {item.label}
              {!isLast && <span className="breadcrumb-dot"> • </span>}
            </Breadcrumb.Item>
          );
        })}
      </Breadcrumb>
    </div>
  );
};

export default Breadcrumb_Comp;